import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { QuoteModal } from "@/components/QuoteModal";
import vesselImage from "@/assets/vessel.jpg";

export const HomeHero = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <section
      data-testid="home-hero"
      className="relative w-full bg-[#042D1F] overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${vesselImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#042D1F]/95 via-[#042D1F]/85 to-[#042D1F]/60" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32 lg:py-40 pb-32 sm:pb-24">
        <p
          data-testid="home-hero-location"
          className="flex items-center gap-2 text-sm font-medium uppercase tracking-[0.2em] text-emerald-300/90 mb-5"
        >
          <MapPin className="h-4 w-4" />
          Maharashtra, India
        </p>

        <h1
          data-testid="home-hero-title"
          className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white"
        >
          RKG NATURALS
        </h1>

        <p
          data-testid="home-hero-tagline"
          className="mt-4 max-w-2xl text-xl sm:text-2xl font-semibold text-white/95"
        >
          Premium Agricultural Products from India
        </p>

        <p
          data-testid="home-hero-subtitle"
          className="mt-4 max-w-xl text-base sm:text-lg text-white/75 leading-relaxed"
        >
          Quality Sourcing • Reliable Supply • Global Business
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to="/products"
            data-testid="home-hero-products-link"
            className="inline-flex items-center gap-2 rounded-full border border-white/30 text-white font-semibold px-7 py-3.5 hover:bg-white/10 transition-colors"
          >
            Explore Products
          </Link>
          <button
            type="button"
            data-testid="home-hero-quote-button"
            onClick={() => setQuoteOpen(true)}
            className="inline-flex items-center gap-2 rounded-full bg-white text-[#042D1F] font-semibold px-7 py-3.5 hover:bg-emerald-50 transition-colors"
          >
            Request a Quote
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>

      <QuoteModal open={quoteOpen} onOpenChange={setQuoteOpen} />
    </section>
  );
};
